// Bedrock API の型定義（非同期処理特化版）

// === 非同期処理用の型定義 ===

// Knowledge Base リクエスト型（非同期処理用）
export interface KnowledgeBaseRequest {
  query: string;
  max_results?: number;
  session_id?: string;
}

// 引用情報の型定義
export interface Citation {
  generated_response_part: {
    textResponsePart: {
      span: {
        start: number;
        end: number;
      };
      text: string;
    };
  };
  retrieved_references: Array<{
    content: string;
    metadata: Record<string, any>;
  }>;
}

// Knowledge Base レスポンス型
export interface KnowledgeBaseResponse {
  query: string;
  generated_response: string;
  citations: Citation[];
  knowledge_base_id: string;
  model_arn: string;
  session_id: string;
  guardrail_action: string;
}

// === 非同期処理関連 ===

// 非同期処理のステータス
export enum AsyncStatus {
  QUEUED = 'QUEUED',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  DB_RESUMING = 'DB_RESUMING'  // Aurora Serverless復旧中
}

// 非同期処理開始のリクエスト型
export interface AsyncKnowledgeBaseRequest {
  query: string;
  max_results?: number;
  session_id?: string;
}

// 非同期処理開始のレスポンス型
export interface AsyncKnowledgeBaseStartResponse {
  requestId: string;
  status: AsyncStatus;
  message: string;
  estimatedCompletionTime?: string;
}

// 非同期処理状況確認のレスポンス型（基本）
export interface AsyncKnowledgeBaseStatusResponse {
  requestId: string;
  status: AsyncStatus;
  message: string;
  estimatedCompletionTime?: string;
  progress?: number;
}

// 非同期処理完了時のレスポンス型
export interface AsyncKnowledgeBaseCompletedResponse extends AsyncKnowledgeBaseStatusResponse {
  status: AsyncStatus.COMPLETED;
  response: KnowledgeBaseResponse; // result → response に変更
  completedAt: string;
  processingTimeMs?: number;
}

// 非同期処理失敗時のレスポンス型
export interface AsyncKnowledgeBaseFailedResponse extends AsyncKnowledgeBaseStatusResponse {
  status: AsyncStatus.FAILED;
  error: string;
}

// Aurora Serverless復旧中のレスポンス型
export interface AsyncKnowledgeBaseDbResumingResponse extends AsyncKnowledgeBaseStatusResponse {
  status: AsyncStatus.DB_RESUMING;
  error?: string;
  retryAfter?: number;  // 再試行推奨時間（秒）
}

// === 共通型定義 ===

// エラーレスポンス型
export interface BedrockError {
  error: string;
  message?: string;
  status_code?: number;
}

// API結果の共通型
export type ApiResult<T> = {
  success: true;
  data: T;
} | {
  success: false;
  error: BedrockError;
};
